import React, { FunctionComponent } from "react";
import { NumberField } from "components/fields/NumberField";
import { Trans } from "@lingui/macro";
import { useIsSinglePerson } from "../hooks/useIsSinglePerson";
import { useFormikContext } from "formik";

export interface Props {}

export const VoorafbetalingenForm: FunctionComponent<Props> = () => {
  const isSinglePerson = useIsSinglePerson();
  const { values } = useFormikContext<any>();

  const sumCodes = (codes: string[]) => {
    return codes
      .reduce((sum, code) => {
        const val = Number.parseFloat(values[code] || 0);
        return sum + val;
      }, 0)
      .toFixed(2);
  };
  return (
    <div id="vooraf" className="breed">
      <div className="vooraf" id="vooraf_declarant">
        <div className="titel">
          <Trans>De aangever</Trans>
        </div>
        <div className="veld">
          <NumberField formatAsString name="c1571" />
        </div>
        <div className="veld">
          <NumberField formatAsString name="c1572" />
        </div>
        <div className="veld">
          <NumberField formatAsString name="c1573" />
        </div>
        <div className="veld">
          <NumberField formatAsString name="c1574" />
        </div>
        <div className="veld" style={{ width: 60 }}>
          {sumCodes(["c1571", "c1572", "c1573", "c1574"])}
        </div>
      </div>
      {!isSinglePerson && (
        <div className="vooraf" id="vooraf_partner">
          <div className="titel">
            <Trans>De partner</Trans>
          </div>
          <div className="veld">
            <NumberField formatAsString name="c2571" />
          </div>
          <div className="veld">
            <NumberField formatAsString name="c2572" />
          </div>
          <div className="veld">
            <NumberField formatAsString name="c2573" />
          </div>
          <div className="veld">
            <NumberField formatAsString name="c2574" />
          </div>
          <div className="veld" style={{ width: 60 }}>
            {sumCodes(["c2571", "c2572", "c2573", "c2574"])}
          </div>
        </div>
      )}

      <div className="vooraf">
        <div className="titel">
          <Trans>Uitgevoerd voor:</Trans>
        </div>
        <div className="veld">
          <p>VA 1</p>
        </div>
        <div className="veld">VA 2</div>
        <div className="veld">VA 3</div>
        <div className="veld">VA 4</div>
        <div className="veld" style={{ width: 60 }}>
          <Trans>Totaal</Trans>
        </div>
      </div>
    </div>
  );
};

VoorafbetalingenForm.displayName = "VoorafbetalingenForm";
